import { QueryOptions, useQuery } from '@tanstack/react-query';

import { getDisconnect, GetXPMConnect } from '../api';

export const useCIMDisconnect = (
  type: 'ADE' | 'XPM',
  queryOptions?: QueryOptions<GetXPMConnect['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['CIMDisconnect', type],
    queryFn: () => getDisconnect(type),
    enabled: false,
  });

  return query;
};
